/* unplugin-vue-components disabled */import { render } from "./borderBox.vue?vue&type=template&id=63d32139&scoped=true"
import script from "./borderBox.vue?vue&type=script&lang=js"
export * from "./borderBox.vue?vue&type=script&lang=js"

import "./borderBox.vue?vue&type=style&index=0&id=63d32139&lang=scss&scoped=true"

import exportComponent from "D:\\项目\\北国之春\\north\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d32139"]])

export default __exports__